import axios from "axios";

export const TOKEN_KEY = "force_token";
export const DEVICE_KEY = "force_device_id";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// A persistent per-device identifier (browser-generated UUID) sent on every
// request as X-Device-Id, so the security audit log can correlate devices.
export function getDeviceId() {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
        id = (crypto.randomUUID && crypto.randomUUID()) ||
            `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
}

export const api = axios.create({ baseURL: API });

// Build an absolute URL for uploaded media (stored as root-relative "/api/uploads/..").
// Full http(s) URLs (e.g. seeded stock images) are returned unchanged.
export function mediaUrl(path) {
    if (!path) return path;
    if (/^https?:\/\//i.test(path)) return path;
    return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers["X-Device-Id"] = getDeviceId();
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
